import { formatNumber, formatPeso } from "../../lib/utils";

// Cell formatting by column type (values may be masked strings for personal details).
export function formatCell(col, v) {
  if (v === null || v === undefined || v === "") return "—";
  if (col.pii) return String(v);
  switch (col.type) {
    case "money": return typeof v === "number" ? formatPeso(v) : String(v);
    case "int": return typeof v === "number" ? formatNumber(v) : String(v);
    case "number": return typeof v === "number" ? v.toLocaleString("en-PH", { maximumFractionDigits: 4 }) : String(v);
    case "pct": return typeof v === "number" ? `${(v * 100).toFixed(1)}%` : String(v);
    case "bool": return v ? "Yes" : "No";
    default: return String(v);
  }
}

export const isNumeric = (col) => ["money", "int", "number", "pct"].includes(col.type) && !col.pii;

const KEY = (table, kind) => `dt-cols-v1-${table}-${kind}`;

export function loadHidden(table, kind) {
  try { return new Set(JSON.parse(localStorage.getItem(KEY(table, kind)) || "[]")); } catch { return new Set(); }
}

export function saveHidden(table, kind, set) {
  try { localStorage.setItem(KEY(table, kind), JSON.stringify([...set])); } catch { /* storage full or blocked */ }
}
